module.exports = __webpack_public_path__ + "img/thunfischkaviarsushiflambiertseitlich.ddb62bb5.png";